'use strict';

/**
 * AboutMeEditor — the rich "About Me" editor on the user's own profile. Same
 * pict-section-markdowneditor (CodeMirror 6 + KaTeX/Mermaid/image preview) as the
 * doc editor, but pasted/dragged/picked images are owned by the User (OwnerType
 * 'User', IDOwner = self) so they live with the profile, and there is no doc host
 * to autosave through. PictView-UserSettings mounts it into #AboutMe-EditorHost
 * (bound to AppData.AboutMeEditor.Segments) and saves on demand via getAllContent.
 */

const libMarkdownEditor = require('pict-section-markdowneditor');

function buildConfiguration()
{
	let tmpConfig = JSON.parse(JSON.stringify(libMarkdownEditor.default_configuration));
	tmpConfig.ViewIdentifier = 'Plansheet-AboutMeEditor';
	tmpConfig.DefaultDestinationAddress = '#AboutMe-EditorHost';
	tmpConfig.TargetElementAddress = '#AboutMe-EditorHost';
	tmpConfig.ContentDataAddress = 'AppData.AboutMeEditor.Segments';
	tmpConfig.DefaultPreviewMode = 'side';
	tmpConfig.EnableRichPreview = true;
	tmpConfig.AutoRender = false;

	if (Array.isArray(tmpConfig.Renderables))
	{
		for (let i = 0; i < tmpConfig.Renderables.length; i++)
		{
			tmpConfig.Renderables[i].DestinationAddress = '#AboutMe-EditorHost';
		}
	}

	return tmpConfig;
}

class PictViewAboutMeEditor extends libMarkdownEditor
{
	_selfIDUser()
	{
		let tmpUser = (this.pict.AppData.Auth && this.pict.AppData.Auth.User) || {};
		return tmpUser.IDUser || 0;
	}

	/**
	 * Pasted / dragged / picked image -> upload to Parime owned by this user
	 * (so it surfaces in their profile media), and insert the blob URL. Returning
	 * true = async handling; false falls back to a base64 embed.
	 */
	onImageUpload(pFile, pSegmentIndex, fCallback)
	{
		let tmpIDUser = this._selfIDUser();
		if (!tmpIDUser || !this.pict.providers.MediaAPI) { return false; }
		this.pict.providers.MediaAPI.upload('User', tmpIDUser, pFile)
			.then((pRow) => fCallback(null, this.pict.providers.MediaAPI.blobURL(pRow.IDMedia)))
			.catch((pErr) => fCallback(pErr.message || String(pErr)));
		return true;
	}

	onContentChange(pSegmentIndex, pContent)
	{
		let tmpHost = this.pict.views['Plansheet-UserSettings'];
		if (tmpHost && typeof tmpHost.onAboutMeChanged === 'function') { tmpHost.onAboutMeChanged(); }
	}
}

module.exports = PictViewAboutMeEditor;
module.exports.default_configuration = buildConfiguration();
